<template>
  <div class="filters on-lg">
    <div class="filter-header">
      <h3 class="header">{{ $txt(`Filters`) }}</h3>
      <div class="sorts">
        <i class="fa-solid fa-search"></i>
        <input
          type="text"
          placeholder="Search here"
          v-model="filterData.article_name_eng"
        />
      </div>
    </div>
    <div class="filter-categories">
      <div
        class="category-item"
        :class="filterData.selectedCategory == 'All' ? 'active' : ''"
        @click="filterData.selectedCategory = 'All'"
      >
        All
      </div>
      <div
        class="category-item"
        v-for="category in categories"
        :key="category.id"
        :class="filterData.selectedCategory == category ? 'active' : ''"
        @click="filterData.selectedCategory = category"
      >
        {{ category }}
      </div>
    </div>
    <div class="filter-expands">
      <div class="expand-item">
        <div class="top" @click="filters.writer = !filters.writer">
          <i class="fa-solid fa-plus" v-if="!filters.writer"></i>
          <i class="fa-solid fa-minus" v-else></i>
          <p>{{ $txt(`WRITER`) }}</p>
        </div>
        <div class="bottom" :class="filters.writer ? 'active' : ''">
          <input
            type="text"
            placeholder="Search by location"
            v-model="filterData.article_writer_eng"
          />
        </div>
      </div>
      <div class="expand-item">
        <div class="top" @click="filters.date = !filters.date">
          <i class="fa-solid fa-plus" v-if="!filters.date"></i>
          <i class="fa-solid fa-minus" v-else></i>
          <p>{{ $txt(`DATE`) }}</p>
        </div>
        <div class="bottom" :class="filters.date ? 'active' : ''">
          <input
            type="date"
            placeholder="Search by location"
            v-model="filterData.article_date"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        writer: false,
        date: false,
      },
      categories: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      filterData: {
        article_name_eng: "",
        article_writer_eng: "",
        article_date: "",
        selectedCategory: "All",
      },
    };
  },
  methods: {},
  watch: {
    filterData: {
      handler() {
        this.$emit("filterData", this.filterData);
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>